import SideMenu from "../../components/admin/SideMenu";
import JudgingSheetLists from "../../components/admin/lists/JudgingSheetLists";

const AdminJudgingSheet = () => {
  return (
    <div className="main-admin">
      <div className="flex">
        <SideMenu />

        <div className="main-contents">
          <h3>採点用紙</h3>

          <JudgingSheetLists />
        </div>
      </div>
    </div>
  );
};

export default AdminJudgingSheet;
